import Tile from '@atlaskit/tile';
import { Box, Text, xcss } from '@atlaskit/primitives';
import { useToken } from '../../../../../Flow/ConsentContextProvider';

const initialStyle = xcss({
  font: 'font.heading.xlarge',
});

const Logo = () => {
  const { clientName } = useToken();
  const displayName = clientName?.trim() || '';
  const initial = (displayName || '?').charAt(0).toUpperCase();

  return (
    <Tile
      label={displayName}
      size="xlarge"
      backgroundColor="color.background.neutral"
      hasBorder
    >
      <Text weight="bold" color="color.text.subtlest" align="center">
        <Box as="span" xcss={initialStyle}>
          {initial}
        </Box>
      </Text>
    </Tile>
  );
};

export default Logo;
